import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getSecondaryOrder } from '../tradingEndpoints'
import { parseSecondaryOrderDetail } from '../tradingParser'

// One secondary order with its fees and settlement steps (Order Details).
export function useSecondaryOrderQuery(orderId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => tradingKeys.order(toValue(orderId))),
    queryFn: () => getSecondaryOrder(toValue(orderId)).then(parseSecondaryOrderDetail),
    enabled: () => Boolean(toValue(orderId)),
  })
}
